export const replaceSerCodigo = (clinica, query) => {
  if (clinica != "") {
    if (clinica == "CHILLÁN") {
      if (process.env.REACT_APP_SERVICIO_CHILLAN != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CHILLAN;
      }
    } else if (clinica == "PUERTO MONTT") {
      if (process.env.REACT_APP_SERVICIO_PTOMONTT != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_PTOMONTT;
      }
    } else if (clinica == "CALAMA") {
      if (process.env.REACT_APP_SERVICIO_CALAMA != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CALAMA;
      }
    } else if (clinica == "LOS ÁNGELES") {
      if (process.env.REACT_APP_SERVICIO_LOSANGELES != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_LOSANGELES;
      }
    } else if (clinica == "CONCEPCIÓN") {
      if (process.env.REACT_APP_SERVICIO_CONCE != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CONCE;
      }
    } else if (clinica == "TALCA") {
      if (process.env.REACT_APP_SERVICIO_TALCA != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_TALCA;
      }
    } else if (clinica == "ANCUD") {
      if (process.env.REACT_APP_SERVICIO_ANCUD != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_ANCUD;
      }
    }
  }

  return query;
};

export const replaceSerCodigoIMG = (clinica, query) => {
  if (clinica != "") {
    if (clinica == "CHILLÁN") {
      if (process.env.REACT_APP_SERVICIO_CHILLAN_IMG != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CHILLAN_IMG;
      }
    } else if (clinica == "PUERTO MONTT") {
      if (process.env.REACT_APP_SERVICIO_PTOMONTT_IMG != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_PTOMONTT_IMG;
      }
    } else if (clinica == "CALAMA") {
      if (process.env.REACT_APP_SERVICIO_CALAMA_IMG != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CALAMA_IMG;
      }
    } else if (clinica == "LOS ÁNGELES") {
      if (process.env.REACT_APP_SERVICIO_LOSANGELES_IMG != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_LOSANGELES_IMG;
      }
    } else if (clinica == "CONCEPCIÓN") {
      if (process.env.REACT_APP_SERVICIO_CONCE_IMG != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CONCE_IMG;
      }
    } else if (clinica == "TALCA") {
      if (process.env.REACT_APP_SERVICIO_TALCA_IMG != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_TALCA_IMG;
      }
    } else if (clinica == "ANCUD") {
      if (process.env.REACT_APP_SERVICIO_ANCUD_IMG != "") {
        query.SER_CODIGO = process.env.REACT_APP_SERVICIO_ANCUD_IMG;
      }
    }
  }
  return query;
};
